import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=48fc62e6&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=ts"
export * from "./FileSelect.vue?vue&type=script&lang=ts"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=48fc62e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc62e6",
  null
  
)

export default component.exports